export default {
  title: 'Artículos populares',
  list: {
    empty_list: {
      title: 'Aún no hay artículos populares.',
    },
    fields: {
      name: 'Nombre',
      orders: 'Pedidos',
      sales: 'Ventas',
    },
  },
};
